import React from 'react';
import { Col, Row, Space } from 'antd';
import { I18n } from '@aws-amplify/core';

import type { BeraReportV2ResultInformations, BeraReportV2Scores } from '@/types/Bera';

import { Line } from './Line';
import { Scores } from './Scores';
import { toCollectionDate, toKnownInjury, toTaskTime, toText } from './utils';
import { SectionTitle } from '../styles';

const COLUMN_GUTTER = 32;
const TITLE_GUTTER = 24;
const LINE_GUTTER = 8;
const COLUMN_SPAN = 8;
const INFORMATIONS_TITLE_SPAN = 16;

interface ResultInformationsProps {
	informations: BeraReportV2ResultInformations;
	scores: BeraReportV2Scores;
}

export function ResultInformations({ informations, scores }: Readonly<ResultInformationsProps>): JSX.Element {
	return (
		<Row gutter={[COLUMN_GUTTER, TITLE_GUTTER]}>
			<Col span={INFORMATIONS_TITLE_SPAN}>
				<SectionTitle>{I18n.get('Informations')}</SectionTitle>
			</Col>
			<Col span={COLUMN_SPAN}>
				<SectionTitle>{I18n.get('Result')}</SectionTitle>
			</Col>
			<Col span={COLUMN_SPAN}>
				<Space direction="vertical" size={LINE_GUTTER}>
					<Line label={I18n.get('Company')} value={toText(informations.companyName)} />
					<Line label={I18n.get('Unit')} value={toText(informations.unitName)} />
					<Line label={I18n.get('Sector')} value={toText(informations.sectorName)} />
					<Line label={I18n.get('Line')} value={toText(informations.lineName)} />
					<Line label={I18n.get('Workstation')} value={toText(informations.workstationName)} />
					<Line label={I18n.get('Cycle')} value={toText(informations.cycleName)} />
					<Line label={I18n.get('Task time')} value={toTaskTime(informations)} />
				</Space>
			</Col>
			<Col span={COLUMN_SPAN}>
				<Space direction="vertical" size={LINE_GUTTER}>
					<Line label={I18n.get('File')} value={toText(informations.fileName)} />
					<Line label={I18n.get('Evaluator')} value={toText(informations.evaluatorName)} />
					<Line label={I18n.get('Work center')} value={toText(informations.workCenter)} />
					<Line label={I18n.get('TLID')} value={toText(informations.taskName)} />
					<Line label={I18n.get('Evaluated employee')} value={toText(informations.operatorEvaluated)} />
					<Line label={I18n.get('Collection date')} value={toCollectionDate(informations.collectionDate)} />
					<Line label={I18n.get('Injury history')} value={toKnownInjury(informations.hasKnownInjury)} />
				</Space>
			</Col>
			<Col span={COLUMN_SPAN}>
				<Scores scores={scores} />
			</Col>
		</Row>
	);
}
